import {
  Container, Grid, Box, Typography, Button
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useStyles } from './style';

export const CameraView = () => {
  const classes = useStyles();
  const history = useHistory();

  const allowCameraHandler = () => {
    history.push('/camera-take');
  };

  return (
    <Container maxWidth="md">
      <Box className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <Box className={classes.cameraImageWrapper}>
              <Box component="img" src="assets/images/camera.svg" className={classes.cameraImage} />
            </Box>
            <Box className={classes.cameraInfoTextWrapper}>
              <Typography variant="body1" className={classes.cameraInfoText}>Please take a new photo of yourself for your patient file. Your photo will not be shared with anyone outside of Averhealth and will only be used to identify you.</Typography>
            </Box>
            <Box className={classes.root}>
              <Grid container rowSpacing={{ xs: 3, sm: 2, md: 4 }}>
                <Grid item xs={12} md={6} className={classes.secondaryBtnWrapper}>
                  <Box px={2}>
                    <Button variant="contained" color="primary" onClick={allowCameraHandler}>
                      Allow camera
                    </Button>
                  </Box>

                </Grid>
                <Grid item xs={12} md={6} className={classes.primaryBtnWrapper}>
                  <Box px={2}>
                    <Button variant="contained" color="secondary" onClick={() => history.push('/personal-info')}>
                      Skip
                    </Button>
                  </Box>

                </Grid>
              </Grid>
            </Box>
            <Box className={classes.root}>
              <Grid container spacing={{ xs: 3, sm: 2, md: 4 }}>
                <Grid item xs={12} md={12}>
                  <Typography variant="body2" className={classes.cameraInfoText}>If you decide to skip, your photo will be taken at your first collection instead.</Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

    </Container>
  );
};
